export default "__VITE_ASSET__e44c8b0a__"